export default __webpack_public_path__ + "static/media/win-prizes3.13484f6b.svg";